






























































































































































/* eslint-disable @typescript-eslint/no-explicit-any */
import { APICarrier } from '@/models/api/carrier.model'
import { APIProvider } from '@/models/api/provider.model'
import { Component, Vue } from 'vue-property-decorator'
import { APIShortcode } from '../../models/api/shortcode.model'

@Component
export default class BillingCodesForm extends Vue {
    loading = true
    data: {[key: string]: unknown} = {}

    cardTitle = ''

    buttonLoading = false

    formData: {[key: string]: any} = {
        billingCodeEnabled: true,
        typeId: {
            id: null
        }
    }

    formValid = false
    formRules = {
        required: [
            (v: string) => !!v || 'This field is required'
        ],
        billingCode: [
            (v: string) => (v && v.length <= 32) || 'Field must be less than 32 characters'
        ],
        billingCodeDescription: [
            (v: string) => (v && v.length <= 255) || 'Field must be less than 255 characters'
        ],
        billingCodePrice: [
            (v: string) => !!v || 'This field is required',
            (v: string) => (v.length <= 10) || 'Field must be less than 10 characters'
        ]
    }

    formModel: { shortcodes: APIShortcode[]; carriers: APICarrier[]; types: object[] } = {
        shortcodes: [],
        carriers: [],
        types: [
            {
                text: 'mt',
                value: 'mt'
            },
            {
                text: 'api',
                value: 'api'
            }
        ]
    }

    async mounted () {
        if (!this.$route.params.action) {
            this.$store.commit('reportError', { code: 1000, message: 'Error, not action sended in route params :(' })
            return
        }

        await Promise.all([this.getShortcodes(), this.getCarriers()])

        switch (this.$route.params.action) {
        case 'edit':
            this.cardTitle = 'Edit Billing Code'
            this.getData()
            break
        case 'add':
            this.cardTitle = 'Create Billing Code'
            this.data = {}
            this.loading = false
            break
        }
    }

    getCarriers () {
        return new Promise<void>(resolve => {
            this.$store.dispatch('getCarriers').then(resp => {
                if (resp.status === 200) {
                    this.formModel.carriers = this.$store.state?.CarriersStore?.carriers?.map(
                        (p: APICarrier) => {
                            return {
                                text: p.carrierName,
                                value: p.carrierId
                            }
                        }
                    )
                    resolve()
                }
            })
        })
    }

    assignShortCodes () {
        this.formModel.shortcodes = this.$store.state?.ShortcodesStore?.shortcodes?.
        filter?.(
            (v: APIShortcode & { providerId: APIProvider & { carrierId: APICarrier}}) => {
                return v.providerId?.carrierId.carrierId === this.formData.carrierId
            }
        )?.map((p: APIShortcode) => {
            return {
                text: p.shortcode,
                value: p.shortcodeId
            }
        })
    }

    handleOnChangeCarrier (v: number) {
        if (typeof v !== 'number') return
        this.formData.carrierId = v
        if (this.formModel.shortcodes.length) {
            this.formData.shortcodeId = null
        }
        this.assignShortCodes()
    }

    async getShortcodes () {
        await this.$store.dispatch('getShortcodes')

        this.assignShortCodes()
    }

    getData () {
        this.loading = true
        if (!this.$route.params.id) {
            this.$store.commit('reportError', { code: 1000, message: 'Error, not id sended in route params :(' })
            this.loading = false
            return
        }
        this.$store.dispatch('getBillingCodesById', this.$route.params.id)
            .then(resp => {
                if (resp?.status === 200) {
                    this.formData = this.$store.state.BillingCodesStore.billingcodeForm
                    this.formData.carrierId = this.formData.shortcodeId?.providerId?.carrierId?.carrierId
                    this.formData.shortcodeId = this.formData.shortcodeId.shortcodeId
                    this.assignShortCodes()
                    this.formData.billingCodePrice = `${this.formData.billingCodePrice}`
                    this.loading = false
                }
            })
    }

    async validateForm () {
        await (this.$refs.form as Vue & { validate: () => boolean }).validate()
        if (!this.formValid) return

        this.buttonLoading = true

        switch (this.$route.params.action) {
        case 'edit':
            this.$store.dispatch('editBillingCodes', this.formData)
                .then(resp => {
                    this.buttonLoading = false
                    if (resp?.status === 200) {
                        this.$store.commit('reportSuccess', 'Done Successfully!')
                        this.$router.push({
                            name: 'BillingCodes'
                        }).then(() => {
                            this.buttonLoading = false
                        })
                    }
                })
            break
        case 'add':
            this.$store.dispatch('createBillingCodes', this.formData)
                .then(resp => {
                    this.buttonLoading = false
                    if (resp?.status === 200) {
                        this.$store.commit('reportSuccess', 'Done Successfully!')
                        this.$router.push({
                            name: 'BillingCodes'
                        }).then(() => {
                            this.buttonLoading = false
                        })
                    }
                })
            break
        }
    }

    getDateFormat (dateString: string) {
        const date = new Date(dateString)
        const day = date.getDate().toString().padStart(2, '0')
        const month = date.getMonth().toString().padStart(2, '0')
        const year = date.getFullYear().toString().padStart(4, '0')
        const hours = date.getHours().toString().padStart(2, '0')
        const minutes = date.getMinutes().toString().padStart(2, '0')
        return `${day}/${month}/${year} - ${hours}:${minutes}`
    }
}
